module.exports = __webpack_public_path__ + "img/attribute_mark_3_on.9df080a.png";